import { combineReducers } from "redux";
import { authReducer } from "./sub-reducers/auth.reducer";

const rootReducers = combineReducers({auth: authReducer});

export default rootReducers;

